const prefix = '@drivex/customCheckbox/';

export const types = {
  CHECK_YES: prefix.concat('CHECK_YES'),
  CHECK_NO: prefix.concat('CHECK_NO'),
};
